import type { SerializedConstructor } from '@langchain/core/load/serializable';

import type { AnthropicTool, PromptTool } from '@/utils/ai-tools';

import { EToolChoice } from '../components/manifest/serialized/common/constants';

export type PlaygroundManifestParts = {
  promptManifest: SerializedConstructor;
  modelManifest: SerializedConstructor;
  options: ManifestOptions;
  isChat: boolean;
};

export interface ManifestOptions {
  tools?: (PromptTool | AnthropicTool)[];
  tool_choice?: EToolChoice | string; // if string, it's the tool name
  parallel_tool_calls?: boolean;
  functions?: unknown;
  function_call?: unknown;
  response_format?: { type: 'json_object' };
  stop?: string[];
  seed?: number;
  requests_per_second?: number;
}

export enum ETemplateFormat {
  MUSTACHE = 'mustache',
  FSTRING = 'fstring',
}
